import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import structuredClone from '@ungap/structured-clone';

export function getJSONFromUrl(url) {
  return fetch(url)
    .then((response) => response.json())
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      console.error(error);
    });
}

export async function loadJSON(url) {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.log("No lake temperature forecast available");
   // console.error(error.message);
    return {"coords": {"valid_time": {"dims": ["valid_time"], "attrs": {}, "data": []}}, "attrs": {}, "dims": {"valid_time": 92}, "data_vars": {"laketemp": {"dims": ["valid_time"], "attrs": {}, "data": []}}};
  }
}

export async function loadAllData() {
  let vmax = await loadJSON(`https://limmattalerwetter.ch/forecast/VMAX_10M.json`);
  let speed = await loadJSON(`https://limmattalerwetter.ch/forecast/WIND_SPEED.json`);
  let dir = await loadJSON(`https://limmattalerwetter.ch/forecast/WIND_DIR.json`);
  let t2m = await loadJSON(`https://limmattalerwetter.ch/forecast/T_2M.json`);
  let precip = await loadJSON(`https://limmattalerwetter.ch/forecast/TOT_PREC.json`);
  let dursun = await loadJSON(`https://limmattalerwetter.ch/forecast/DURSUN.json`);
  let twater = await loadJSON(`https://limmattalerwetter.ch/forecast/laketemp.json`);
  let qff = await loadJSON(`https://limmattalerwetter.ch/forecast/PMSL.json`);
  return [vmax, speed, dir, t2m, precip, dursun, twater, qff];
}

export function getStationData(forecast, name, lake_name, qff_name) {

  // Must ensure to make a deep copy to avoid overwriting original forecast
  let [vmax, speed, dir, t2m, precip, dursun, twater, qff] = structuredClone(forecast);
  // Select relevant forecast data
  let station = speed.coords.site.data.indexOf(name);
  vmax.data = vmax.data[station];
  speed.data = speed.data[station];
  dir.data = dir.data[station];
  t2m.data = t2m.data[station];
  precip.data = precip.data[station];
  dursun.data = dursun.data[station];

  // Select relevant lake temperature forecast
  if (lake_name) {
    let lake = twater.coords.lake.data.indexOf(lake_name);
    twater.data_vars.laketemp.data = twater.data_vars.laketemp.data[lake];
  }

  // Select relevant QFF difference
  let difference = qff.coords.site.data.indexOf(qff_name);
  qff.data = qff.data[difference];

  return [vmax, speed, dir, t2m, precip, dursun, twater, qff];
}

export async function loadData(abbr) {
  let vmax = await loadJSON(`https://limmattalerwetter.ch/forecast/${abbr}-VMAX_10M.json`);
  let speed = await loadJSON(`https://limmattalerwetter.ch/forecast/${abbr}-WIND_SPEED.json`);
  let dir = await loadJSON(`https://limmattalerwetter.ch/forecast/${abbr}-WIND_DIR.json`);
  let t2m = await loadJSON(`https://limmattalerwetter.ch/forecast/${abbr}-T_2M.json`);
  let precip = await loadJSON(`https://limmattalerwetter.ch/forecast/${abbr}-TOT_PREC.json`);
  let dursun = await loadJSON(`https://limmattalerwetter.ch/forecast/${abbr}-DURSUN.json`);
  let twater = await loadJSON(`https://limmattalerwetter.ch/forecast/${abbr}-laketemp.json`);
  //   const forecast_date = t2m.coords.valid_time.data.map(
  //     (date) => new Date(date),
  //   );
  return [vmax, speed, dir, t2m, precip, dursun, twater];
}

export async function loadQFF(abbr) {
  let qff_zue_lug = await loadJSON(`https://limmattalerwetter.ch/forecast/QFF_${abbr}-PMSL.json`);
  return qff_zue_lug;
}

export async function getJSON(url) {
  const response = await fetch(url);
  const data = await response.json();
  return data;
}

export function round(value, precision) {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

export function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    hour = "" + d.getHours(),
    minute = "" + d.getMinutes(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  if (hour.length < 2) hour = "0" + hour;
  if (minute.length < 2) minute = "0" + minute;
  return [year, month, day, hour, minute].join("");
}

export function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
